import jwtService from "services/jwtService";

export const RESEND_TOKEN_FETCH_START = "RESEND_TOKEN_FETCH_START";
export const RESEND_TOKEN_FETCH_SUCCESS = "RESEND_TOKEN_FETCH_SUCCESS";
export const RESEND_TOKEN_FETCH_FAILURE = "RESEND_TOKEN_FETCH_FAILURE";

export function submitResendToken({ type, onSuccess, onError }) {
  return (dispatch, getState) => {
    dispatch({
      type: RESEND_TOKEN_FETCH_START,
    });

    const { auth } = getState();

    console.log(type);

    jwtService
      .resendToken({
        user_id:
          type === 4 ? auth.register.data.user_id : auth.forgot.data.user_id,
        type,
      })
      .then((response) => {
        onSuccess();
        return dispatch({
          type: RESEND_TOKEN_FETCH_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        return dispatch({
          type: RESEND_TOKEN_FETCH_FAILURE,
          payload: error,
        });
      });
  };
}
